


export function InstrucoesSubcontratacao() {

    return (
        <div className="text-lg">
            <div ><span className="font-bold">1.</span>Consulte dados das obras em APPRodrimaq&gt;Obras&gt;Data de entrega xxx&gt;Subcontratação.</div>
            <hr className="mb-5" />
            <div><span className="font-bold">2.</span> Consulte a escala de trabalho (gráfico gant) e, caso entenda, o setor Projeto/Industrial afim de identificar a
                necessidade de subcontratação (Erosão Fio, Corte Laser, Quinagem, …)</div>
            <hr className="mb-5" />
            <div><span className="font-bold">3.</span> Proceda à encomenda do serviço ao fornecedor com Nota de Encomenda via APP e através de e-mail,
                acompanhada do desenho ou da peça (no caso de retrabalho).</div>
            <hr className="mb-5" />
            <div ><span className="font-bold">4.</span>  No ficheiro de “Expedição”, que deve ser sempre atualizado consoante as entradas/saídas da estante,
                introduza a obra no local com o destinado serviço de sub-contratação.</div>
            <hr className="mb-5" />

        </div>

    )


}